import { requestBuilder } from '../../http/RequestBuilder';
import type { IBill, PartialBill } from '../types/Bill';

type BillsApiUpdateBillParams = Pick<IBill, 'membershipId' | 'id'>;

export type UpdateBillBody = Pick<
    IBill,
    | 'accountId'
    | 'displayName'
    | 'payee'
    | 'amount'
    | 'cadence'
    | 'timingLabel'
    | 'timingDescription'
    | 'category'
    | 'lastPaidAt'
    | 'memberMarkedAsSwitched'
>;

const useUpdateBill = requestBuilder.mutation<
    PartialBill,
    UpdateBillBody,
    BillsApiUpdateBillParams
>({
    endpoint: ({ membershipId, id }) =>
        `/api/holistic-bills/${membershipId}/bill/${id}/update`,
    method: 'PATCH',
});

export default useUpdateBill;
